import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/** One fact about the dataset: what it is, then its value. */
export const FactRow = memo(
  ({ label, value }: { label: string; value: string }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ flexDirection: 'row', gap: rpx(12) }}>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ width: rpx(72) }}
        >
          {label}
        </Typography.Text>
        <Typography.Text
          size={rpx(13)}
          color={aiColors.foreground}
          style={{ flex: 1 }}
        >
          {value}
        </Typography.Text>
      </View>
    );
  },
);
